<template>
  <div style="width: 100%; height: 100%; position: absolute">
    <h1
      style="width: 100%; height: 70px; position: absolute; color: white; font-weight: bold; font-size: 42px; line-height: 70px; padding-left: 20px; text-align: left">
      Subcontractors Non-conformance (Accumulative)
    </h1>
    <div v-if="dataNotNull" key="1" class="snc_aDiv"
         style="width: 100%; height: 793px; position: absolute; bottom: 0">
      <div class="container1" style="height: 100%;" @click="showDetail"></div>
    </div>
    <div v-else key="2"
         style="width: 100%; height: 793px; position: absolute; bottom: 0; line-height: 793px; color: #6CF; font-size: 64px;">
      No Data !
    </div>

    <div class="snc_detail" v-show="showflag" id="snc_detail">
      <div
        style="width: 90%; height: 80px; position: absolute; color: #333; font-size: 42px; line-height: 80px; padding-left: 20px; text-align: left;z-index: 9999;font-weight: bold;background-color: #F8F8F8;border: 0">
        Subcontractors Non-conformance (Accumulative)
      </div>
      <div class="close_img_gentry" style="z-index: 9999" @click="detailClose"></div>
      <el-scrollbar style="height:100%">
        <div style="margin-top:100px; width: 100%; height: 540px">
          <el-collapse accordion>
            <el-collapse-item v-for="(item, index) in detail_data" :key="'snc_' + index" :title="item.name">
              <div class="rejected_content">
                <div class="item_type">
                  <div class="type_con">Type</div>
                  <div class="type_cnt">Cnt</div>
                </div>
                <div class="item_type" v-for="(one, innerIndex) in item.list" :key="'snc_one_' + innerIndex">
                  <div class="type_con">{{ one.name }}</div>
                  <div class="type_cnt">{{ one.count }}</div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {

  name: "snc_a",

  props: ['project_id'],

  data() {
    return {
      my_project_id: this.project_id,
      legendArr: [],
      color: this.$store.state.color.chart_color,
      myChart: null,
      name: "snc_a",
      dataNotNull: true,
      showflag: false,
      detail_data: []
    }
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
  },
  methods: {
    init() {
      // this.$root.charts.push(this.myChart)
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },

    detailClose() {
      this.showflag = false
    },
    showDetail() {
      this.showflag = true
    },
    dragFunc(id) {
      var Drag = document.getElementById(id);
      Drag.onmousedown = function (event) {
        var ev = event || window.event;
        event.stopPropagation();
        var disX = ev.clientX - Drag.offsetLeft;
        var disY = ev.clientY - Drag.offsetTop;
        document.onmousemove = function (event) {
          var ev = event || window.event;
          Drag.style.left = ev.clientX - disX + "px";
          Drag.style.top = ev.clientY - disY + "px";
          Drag.style.cursor = "move";
        };
      };
      Drag.onmouseup = function () {
        document.onmousemove = null;
        this.style.cursor = "default";
      }
    },

    analysisResult(result) {
      var safetys = []
      var legends = []
      var data_list = []
      for (var i in result) {
        let cindex = legends.indexOf(result[i].short_name.substring(0, 13) + '\n' + result[i].short_name.substring(13, result[i].short_name.length))
        if (cindex < 0) {
          let last_index = legends.length - 1
          if (last_index >= 0) {
            this.detail_data.push({name: legends[last_index], count: safetys[last_index], list: data_list})
          }
          legends.push(result[i].short_name.substring(0, 13) + '\n' + result[i].short_name.substring(13, result[i].short_name.length))
          safetys.push(parseInt(result[i].count))
          data_list = []
        } else {
          safetys[cindex] += parseInt(result[i].count)
        }
        data_list.push({
          name: result[i].findings_name_en,
          count: parseInt(result[i].count),
          short: result[i].short_name
        })
      }
      let last_index = legends.length - 1
      this.detail_data.push({name: legends[last_index], count: safetys[last_index], list: data_list})
      return {legends: legends, safetys: safetys}
    }
  },
  mounted() {
    let that = this
    var name = window.localStorage.getItem('token_key')
    if ("videmo" == name) {
      this.my_project_id = "3177"
    }
    this.myChart = echarts.init(document.querySelector('.snc_aDiv .container1'))
    this.myChart.setOption({
      grid: {
        bottom: 100
      },
      tooltip: {
        show: true,
        trigger: 'axis',
        textStyle: {
          fontSize: 40
        },
        formatter: function (params) {
          return params[0].name.replace(/\n/, "") + ': ' + params[0].value
        },
      },
      dataZoom: [
        {
          show: true,
          realtime: true,
          xAxisIndex: [0],
          left: '95%',
          startValue: 0, // 从头开始。
          endValue: 2,  // 一次性展示5个。
          showDetail: false,
          zoomLock: true,
          width: '3%',
          orient: "vertical"
        }
      ],
      xAxis: {
        type: "category",
        data: [],
        axisLine: {
          lineStyle: {
            color: '#FFF',
          }
        },
        axisLabel: {
          interval: 0,
          fontSize: 22
        }
      },
      yAxis: {
        type: 'value',
        minInterval: 1,
        axisLine: {
          lineStyle: {
            color: '#6CF',
          },

        },
        axisLabel: {
          fontSize: 42
        }
      },
      series: [{
        data: [],
        barWidth: '25%',
        barCategoryGap: '5%',
        type: 'bar',
        itemStyle: {
          normal: {
            color: function (params) {
              return that.color[params.dataIndex]
            }
          },
          //鼠标悬停时：
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }],
    })

    this.myChart.showLoading({
      text: '',
      color: '#66CCFF',
      maskColor: 'rgba(255, 255, 255, 0)',
    });

    let postData = {
      project_id: this.my_project_id,
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token'),
      // token: "lalala",
      // start_date: this.getNowFormatDate(),
      // end_date: this.getNowFormatDate()
    }
    axios.post(this.$store.getters.getCmsServer + "DBProjSubNonConType", postData).then(resp => {
      var errNo = resp.data.errno
      var errStr = resp.data.errstr_cn
      this.myChart.hideLoading()
      if (errNo == "0") {
        this.dataNotNull = true
        var result = resp.data.result;
        var data = this.analysisResult(result)
        this.myChart.setOption({
          xAxis: {
            data: data.legends,
          },
          series: [
            {
              data: data.safetys
            }
          ]
        })
      } else {
        this.dataNotNull = false
      }
    }).catch(error => {
      alert(error)
      this.myChart.hideLoading()
      this.dataNotNull = false
    })

    // this.myChart.on('click', function (param) {
    //     that.showflag = true
    // });

    this.dragFunc("snc_detail")


    // this.init()
  }
}
</script>

<style lang="stylus" scoped>

.snc_detail {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  position: absolute;
  width: 90%;
  height: 110%;
  left: 5%;
  top: 12%;
  text-align: left;
  font-size: 40px;
  z-index: 1000;
  color #333333
}

.rejected_content {
  width 100%
  max-height 330px
  overflow scroll
  display flex
  flex-direction column
  text-align center
}

.item_type {
  display flex
  width 100%
  height 60px
}

.type_con {
  flex 3
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.type_cnt {
  flex 1
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.el-collapse-item__wrap {
  background-color rgb(248, 248, 248)
}

.el-collapse-item__content {
  background-color rgb(248, 248, 248)
  font-size 32px
  margin-left 40px
  margin-right 40px
}
</style>



// WEBPACK FOOTER //
// src/components/safety_manage/snc_a.vue